import React, { useEffect, useMemo } from 'react'
import { useSnackbar } from 'notistack'
import { InlineWidget } from 'react-calendly'

export interface CalendlyInlineWidgetProps {
  confirmationAlert?: (boolean) => void
  bookingComplete?: (boolean) => void
  url: string
  hideEventDetails?: boolean
  email?: string
  name?: string
  companyName?: string
  phone?: string
  styles?: React.CSSProperties
}

export default function CalendlyInlineWidget({
  confirmationAlert,
  bookingComplete,
  url,
  hideEventDetails,
  email,
  name,
  companyName,
  phone,
  styles
}: CalendlyInlineWidgetProps) {
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    if (confirmationAlert) {
      const handleCalendlyEvents = (ev) => {
        if (ev.data.event === 'calendly.date_and_time_selected') {
          confirmationAlert(true)
        }
        if (ev.data.event === 'calendly.event_scheduled') {
          confirmationAlert(false)
          bookingComplete(true)
          enqueueSnackbar('Demo Booked', { variant: 'success', id: 'demo-booked' })
        }
      }
      window.addEventListener('message', handleCalendlyEvents)
      return () => window.removeEventListener('message', handleCalendlyEvents)
    }
  }, [])

  const widget = useMemo(() => {
    return (
      <InlineWidget
        url={hideEventDetails ? `${url}?hide_event_type_details=1` : url}
        prefill={{
          email: email ?? '',
          name: name ?? '',
          customAnswers: {
            a1: companyName ?? '',
            a2: phone ? `1${phone}` : ''
          }
        }}
        styles={styles}
      />
    )
  }, [url, email, name, companyName, phone])

  return widget
}
